import React, { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { NavigationPaths } from '../constants';

interface PrivateRouteProps {
  children?: ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  if (!isAuthenticated) {
    return (
      <Navigate
        to={NavigationPaths.LOGIN}
        replace
      />
    );
  }

  return children ? <>{children}</> : <Outlet />;
};

export default PrivateRoute;
